// Shard 7 — WarRoom.jsx + Governance.jsx page-local text.
// Flat English -> Marathi phrase table, merged into the central TRANSLATIONS
// dictionary. Keys are the exact English strings passed to t(...) at their
// render sites (headings, table cells, badges, chart legend/axis labels,
// mock-data field values). Numbers, dates, IDs/codes and pure acronyms are
// intentionally not wrapped/translated at the call sites, so they have no
// entries here.
const shard7 = {
  // ── Governance page tab labels ──
  "DPDP & Privacy": "डीपीडीपी व गोपनीयता",
  "Responsible AI": "जबाबदार एआय",
  "Access & Audit": "प्रवेश व लेखापरीक्षण",
  "SOC / Cyber": "एसओसी / सायबर",
  "Sovereignty & Bhasini": "सार्वभौमत्व व भाषिणी",

  // ── SectionHeader / MetricCard / ChartCard / GaugeCard props (auto-t()'d) ──
  "Inter-Agency War Room Workflow": "आंतर-संस्था वॉर रूम कार्यप्रणाली",
  "360° unified command · decision approval queue · cross-agency requests · SITREP · escalation pipeline · Shahi Snan planning · responsibility matrix · command authority chain · VIP coordination · audit trail · SLA analytics":
    "360° एकत्रित कमांड · निर्णय मंजुरी रांग · आंतर-संस्था विनंत्या · सिटरेप · वाढ प्रक्रिया · शाही स्नान नियोजन · जबाबदारी सारणी · कमांड प्राधिकरण साखळी · व्हीआयपी समन्वय · लेखापरीक्षण नोंदी · SLA विश्लेषण",
  "5 PENDING": "५ प्रलंबित",
  "Active Tasks": "सक्रिय कामे",
  "Pending Approval": "मंजुरी प्रलंबित",
  "Completed Today": "आज पूर्ण झाली",
  "SLA Breaches": "SLA उल्लंघन",
  "Agencies Online": "संस्था कार्यरत",
  "Decisions Pending": "निर्णय प्रलंबित",
  "AI Actions Q.": "एआय कृती रांग",
  "Cross-Agency Req.": "आंतर-संस्था विनंत्या",
  "Command Task Board — All Departments": "कमांड कार्य फलक — सर्व विभाग",
  "Full inter-agency task register with ownership, SLA and approval status": "जबाबदारी, SLA व मंजुरी स्थितीसह संपूर्ण आंतर-संस्था कार्य नोंदवही",
  "Agency Coordination Matrix": "संस्था समन्वय सारणी",
  "Task completion · SLA performance · last contact per department": "कार्य पूर्णता · SLA कामगिरी · प्रत्येक विभागाचा शेवटचा संपर्क",
  "Task Creation vs Completion — Hourly": "कार्य निर्मिती वि. पूर्णता — तासागणिक",
  "War room task throughput with SLA breach incidents": "SLA उल्लंघन घटनांसह वॉर रूम कार्य कार्यक्षमता",
  "Inter-Agency Responsibility Matrix": "आंतर-संस्था जबाबदारी सारणी",
  "Domain ownership · primary + secondary agencies · escalation triggers and chain — Simhastha 2027": "क्षेत्र मालकी · प्राथमिक + दुय्यम संस्था · वाढ चालना व साखळी — सिंहस्थ २०२७",
  "Command Authority Chain": "कमांड प्राधिकरण साखळी",
  "Authorization levels · who can approve what · 2FA requirements · Simhastha 2027 governance": "प्राधिकरण स्तर · कोण काय मंजूर करू शकतो · 2FA आवश्यकता · सिंहस्थ २०२७ प्रशासन",
  "Maha Kumbh AI Audit Log — Recent Entries": "महा कुंभ एआय लेखापरीक्षण नोंदी — अलीकडील नोंदी",
  "Full DPDP 2023 compliant audit trail of all officer and AI actions": "सर्व अधिकारी व एआय कृतींची संपूर्ण DPDP 2023 अनुरूप लेखापरीक्षण नोंद",
  "Field Officer Board — Live Status": "क्षेत्रीय अधिकारी फलक — थेट स्थिती",
  "Key officers on ground with current zone, task and last contact": "सद्य विभाग, कार्य व शेवटच्या संपर्कासह प्रमुख क्षेत्रीय अधिकारी",
  "Officers In Active Escalation": "सक्रिय वाढीव प्रकरणातील अधिकारी",
  "Only officers currently part of a live escalation — the full duty roster is on Unified Command":
    "सध्या सक्रिय वाढीव प्रकरणात सहभागी अधिकारीच येथे — संपूर्ण कर्तव्य यादी एकीकृत कमांडवर उपलब्ध",
  "Only officers currently part of a live escalation — the full duty roster is alongside":
    "सध्या सक्रिय वाढीव प्रकरणात सहभागी अधिकारीच येथे — संपूर्ण कर्तव्य यादी शेजारीच उपलब्ध",
  "No officers currently escalated — all clear": "सध्या कोणतेही अधिकारी वाढीव प्रकरणात नाहीत — सर्व सुरळीत",
  "Total Officers": "एकूण अधिकारी",
  "Department Task Load Overview": "विभागनिहाय कार्यभार आढावा",
  "Total, completed and pending tasks across all 7 War Room departments": "सर्व ७ वॉर रूम विभागांतील एकूण, पूर्ण व प्रलंबित कामे",

  "DPDP, Cybersecurity & Responsible AI Governance": "DPDP, सायबरसुरक्षा व जबाबदार एआय प्रशासन",
  "DPDP 2023 · consent management · RBAC · audit logs · data retention · AI governance · privacy-by-design · SOC/SIEM · cyber risk · data sovereignty · Bhasini multilingual AI · Responsible AI principles — Maha AI · Simhastha 2027":
    "DPDP 2023 · संमती व्यवस्थापन · RBAC · लेखापरीक्षण नोंदी · डेटा जतन · एआय प्रशासन · गोपनीयता-रचित · SOC/SIEM · सायबर जोखीम · डेटा सार्वभौमत्व · भाषिणी बहुभाषिक एआय · जबाबदार एआय तत्त्वे — महा एआय · सिंहस्थ २०२७",
  "97.1% COMPLIANT": "९७.१% अनुरूप",
  "Privacy Score": "गोपनीयता गुण",
  "Audit Entries": "लेखापरीक्षण नोंदी",
  "Cyber Events": "सायबर घटना",
  "Human Review": "मानवी पुनरावलोकन",
  "Consent Records": "संमती नोंदी",
  "AI Models Live": "सक्रिय एआय प्रतिमाने",
  "Bhasini Languages": "भाषिणी भाषा",
  "Data Sovereignty": "डेटा सार्वभौमत्व",
  "Data Minimisation": "डेटा किमानीकरण",
  "At-collection": "संकलनाच्या वेळी",
  "Human Review Rate": "मानवी पुनरावलोकन दर",
  "All AI actions": "सर्व एआय कृती",
  "AI Explainability": "एआय स्पष्टीकरणक्षमता",
  "SHAP/LIME active": "SHAP/LIME सक्रिय",
  "DPDP 2023 Compliance Controls": "DPDP 2023 अनुरूपता नियंत्रणे",
  "All 8 statutory controls — score · status · last audit · notes": "सर्व ८ वैधानिक नियंत्रणे — गुण · स्थिती · शेवटचे लेखापरीक्षण · टिपा",
  "Consent Management Panel": "संमती व्यवस्थापन फलक",
  "7 data categories · legal basis · consent count · withdrawals · PII flag": "७ डेटा प्रवर्ग · कायदेशीर आधार · संमती संख्या · मागे घेतलेल्या संमती · PII चिन्ह",
  "Data Retention Dashboard": "डेटा जतन डॅशबोर्ड",
  "8 data categories · retention period · auto-delete status · next purge date · storage volume": "८ डेटा प्रवर्ग · जतन कालावधी · स्वयं-हटवणे स्थिती · पुढील नष्टीकरण तारीख · साठवण प्रमाण",
  "Privacy-by-Design Controls — Per Module": "गोपनीयता-रचित नियंत्रणे — प्रत्येक घटकानुसार",
  "Anonymisation · pseudonymisation · data minimisation · biometric storage policy per Maha Kumbh AI module": "निनावीकरण · छद्मनामीकरण · डेटा किमानीकरण · प्रत्येक महा कुंभ एआय घटकाचे जैवमापन साठवण धोरण",
  "AI Model Governance Register": "एआय प्रतिमान प्रशासन नोंदवही",
  "8 active AI models · human-in-loop · explainability method · bias check · training data declaration": "८ सक्रिय एआय प्रतिमाने · मानवी सहभाग · स्पष्टीकरण पद्धत · पूर्वग्रह तपासणी · प्रशिक्षण डेटा घोषणा",
  "AI Transparency Report — Monthly": "एआय पारदर्शकता अहवाल — मासिक",
  "AI actions raised · human reviewed · officer overrides — published monthly": "उपस्थित एआय कृती · मानवी पुनरावलोकन · अधिकारी अधिलिखन — मासिक प्रकाशित",
  "Role-Based Access Control (RBAC)": "भूमिका-आधारित प्रवेश नियंत्रण (RBAC)",
  "6 roles · access level · users · permissions · 2FA enforcement": "६ भूमिका · प्रवेश स्तर · वापरकर्ते · परवानग्या · 2FA अंमलबजावणी",
  "System Audit Trail — Immutable Log": "प्रणाली लेखापरीक्षण नोंद — अपरिवर्तनीय नोंद",
  "All operator and AI actions · DPDP 2023 compliant · 22,840 entries today": "सर्व कार्यकर्ता व एआय कृती · DPDP 2023 अनुरूप · आज २२,८४० नोंदी",
  "SOC / SIEM — Event Trend": "SOC / SIEM — घटना कल",
  "Security events · alerts · blocked actions — hourly": "सुरक्षा घटना · इशारे · अवरोधित कृती — तासागणिक",
  "Event Category Breakdown": "घटना प्रवर्ग विभाजन",
  "Security event types today — all 10 events categorised": "आजचे सुरक्षा घटना प्रकार — सर्व १० घटना वर्गीकृत",
  "Cyber Incident Log — SIEM Feed": "सायबर घटना नोंद — SIEM फीड",
  "10 security events today · all external intrusion attempts blocked": "आज १० सुरक्षा घटना · सर्व बाह्य घुसखोरी प्रयत्न अवरोधित",
  "Cyber Risk Analytics — Attack Vector Assessment": "सायबर जोखीम विश्लेषण — हल्ला मार्ग मूल्यांकन",
  "6 attack vectors · inherent risk · incidents · mitigated · residual risk score": "६ हल्ला मार्ग · अंगभूत जोखीम · घटना · कमी केलेली · उर्वरित जोखीम गुण",
  "Data Sovereignty Infrastructure": "डेटा सार्वभौमत्व पायाभूत सुविधा",
  "NIC cloud · STQC certification · MeitY compliance · geo-fencing · all components India-hosted": "NIC क्लाऊड · STQC प्रमाणन · MeitY अनुरूपता · भू-कुंपण · सर्व घटक भारतात होस्ट केलेले",
  "Data Residency — Legal Compliance Framework": "डेटा वास्तव्य — कायदेशीर अनुरूपता चौकट",
  "6 applicable laws · requirement · compliance status · verification mechanism": "६ लागू कायदे · आवश्यकता · अनुरूपता स्थिती · पडताळणी यंत्रणा",

  // ── WarRoom banner / SITREP ──
  "Maha Kumbh AI WAR ROOM — COLLECTOR NASHIK — 14:33 IST — ALL AGENCIES ONLINE": "महा कुंभ एआय वॉर रूम — जिल्हाधिकारी नाशिक — १४:३३ IST — सर्व संस्था कार्यरत",
  "Maha Kumbh AI Inter-Agency Command — Simhastha 2027": "महा कुंभ एआय आंतर-संस्था कमांड — सिंहस्थ २०२७",
  "7 agencies live · 16 active tasks · 5 pending decisions · 38 resolved today · 1 SLA breach (Transport) · Next Shahi Snan: 11 Jul 2027 (32 days) · CM visit 15:30 today":
    "७ संस्था कार्यरत · १६ सक्रिय कामे · ५ प्रलंबित निर्णय · आज ३८ निकाली · १ SLA उल्लंघन (वाहतूक) · पुढील शाही स्नान: ११ जुलै २०२७ (३२ दिवस) · आज सीएम भेट १५:३०",
  "agencies live": "संस्था कार्यरत",
  "active tasks": "सक्रिय कामे",
  "pending decisions": "प्रलंबित निर्णय",
  "resolved today": "आज निकाली",
  "SLA breach (Transport)": "SLA उल्लंघन (वाहतूक)",
  "Next Shahi Snan: 11 Jul 2027 (32 days) · CM visit 15:30 today": "पुढील शाही स्नान: 11 जुलै 2027 (32 दिवस) · आज सीएम भेट 15:30",
  "done": "पूर्ण",
  "Daily SITREP": "दैनिक सिटरेप",
  "Auto-Generated": "स्वयं-निर्मित",
  "AI + Human Verified": "एआय + मानवी पडताळणीकृत",
  "Immediate Action Items": "तात्काळ कृती मुद्दे",
  "Crowd Status": "गर्दी स्थिती",
  "Incident Summary": "घटना सारांश",
  "Resource Status": "संसाधन स्थिती",
  "Next Shahi Snan": "पुढील शाही स्नान",
  "6,84,210 pilgrims active. Ramkund Ghat at critical 92% density. Panchvati at 81%.":
    "६,८४,२१० यात्रेकरू सक्रिय. रामकुंड घाट येथे गंभीर ९२% घनता. पंचवटी येथे ८१%.",
  "18 open incidents: 6 critical, 9 high, 3 medium. 57 resolved since 06:00.":
    "१८ प्रलंबित घटना: ६ गंभीर, ९ उच्च, ३ मध्यम. ०६:०० पासून ५७ निकाली.",
  "Police: 6,420 deployed. Health: 1,680. NDRF on standby. 34 ambulances active.":
    "पोलीस: ६,४२० तैनात. आरोग्य: १,६८०. एनडीआरएफ सज्ज. ३४ रुग्णवाहिका सक्रिय.",
  "11 July 2027 (Shravan Purnima) — Peak day estimate 9 lakh.": "११ जुलै २०२७ (श्रावण पौर्णिमा) — पर्वणी दिनाचा अंदाज ९ लाख.",
  "Reinforce Ramkund Entry 2 with 3 additional platoons — DCP Nashik": "रामकुंड प्रवेशद्वार २ साठी ३ अतिरिक्त तुकड्यांचे बळकटीकरण — डीसीपी नाशिक",
  "Redirect water tanker T-14 to Station 8 — JE NMC (ETA 12 min)": "पाण्याचा टँकर T-14 केंद्र ८ कडे वळवा — कनिष्ठ अभियंता एनएमसी (अंदाजे आगमन १२ मिनिटे)",
  "Open Camp Delta for shelter overflow — Revenue Dept": "अतिरिक्त निवाऱ्यासाठी शिबिर डेल्टा उघडा — महसूल विभाग",
  "Activate CM communication protocol for VIP visit — SP Nashik": "व्हीआयपी भेटीसाठी सीएम संवाद प्रोटोकॉल सक्रिय करा — एसपी नाशिक",

  // ── Command Operations Center tabs ──
  "Command Operations Center": "कमांड कार्यसंचालन केंद्र",
  "Decision Queue": "निर्णय रांग",
  "Cross-Agency Requests": "आंतर-संस्था विनंत्या",
  "War Room Log": "वॉर रूम नोंद",
  "VIP Coordination": "व्हीआयपी समन्वय",

  // ── Decision Queue ──
  "⚠ All AI-generated recommendations require human officer approval before action is taken — DPDP 2023 / Maha Kumbh AI Protocol":
    "⚠ सर्व एआय-निर्मित शिफारशींना कृती करण्यापूर्वी मानवी अधिकाऱ्याची मंजुरी आवश्यक — DPDP 2023 / महा कुंभ एआय प्रोटोकॉल",
  "Req by": "विनंतीकर्ता",
  "Auth": "प्राधिकरण",
  "Deadline": "अंतिम मुदत",
  "AI conf": "एआय विश्वासार्हता",
  "Approve": "मंजूर करा",
  "Escalate ↑": "वाढवा ↑",
  "HIGH": "उच्च",
  "MED": "मध्यम",
  "LOW": "कमी",
  "CRITICAL": "गंभीर",
  "Crowd Control": "गर्दी नियंत्रण",
  "Water Supply": "पाणीपुरवठा",
  "Shelter": "निवारा",
  "Preparedness": "सज्जता",
  "Public Advisory": "सार्वजनिक सूचना",
  "Seal Ramkund Entry 2 — crowd density 9.2/m²": "रामकुंड प्रवेशद्वार २ बंद करा — गर्दीची घनता ९.२/मी²",
  "Redirect tanker TK-18 from Gangapur to Panchvati": "टँकर TK-18 गंगापूरहून पंचवटीकडे वळवा",
  "Activate Camp Delta overflow — shelter 138%": "शिबिर डेल्टा अतिरिक्त निवारा सक्रिय करा — क्षमता १३८%",
  "Pre-position NDRF Platoon 1 at Ramkund": "एनडीआरएफ तुकडी १ रामकुंड येथे पूर्व-तैनात करा",
  "Issue public advisory — carry water, temp 41°C": "सार्वजनिक सूचना जारी करा — पाणी सोबत ठेवा, तापमान ४१°से",
  "AI System": "एआय प्रणाली",
  "NMC JE R.Patil": "एनएमसी कनिष्ठ अभियंता आर. पाटील",
  "Revenue Officer": "महसूल अधिकारी",
  "NDRF Commander": "एनडीआरएफ कमांडर",
  "CMO Nashik": "सीएमओ नाशिक",
  "DCP Nashik": "डीसीपी नाशिक",
  "Exec. Eng.": "कार्यकारी अभियंता",
  "Dist. Collector": "जिल्हाधिकारी",
  "CM EOC": "सीएम ईओसी",
  "DM Office": "डीएम कार्यालय",

  // ── Cross-Agency Requests ──
  "Health Dept": "आरोग्य विभाग",
  "Police Dept": "पोलीस विभाग",
  "NMC Municipal": "एनएमसी महानगरपालिका",
  "Revenue Dept": "महसूल विभाग",
  "NDRF": "एनडीआरएफ",
  "Transport": "वाहतूक",
  "Maha Kumbh AI": "महा कुंभ एआय",
  "Municipal NMC": "एनएमसी महानगरपालिका",
  "Police escort for AMB-07 — Trimbak Rd": "AMB-07 साठी पोलीस बंदोबस्त — त्र्यंबक रस्ता",
  "Open overflow shelter OFZ-B — Camp 3 full": "अतिरिक्त निवारा OFZ-B उघडा — शिबिर ३ पूर्ण भरले",
  "Bus BR-09 for 800 displaced pilgrims": "८०० विस्थापित यात्रेकरूंसाठी बस BR-09",
  "CCTV scan — missing child Gate 5 area": "सीसीटीव्ही तपासणी — हरवलेले मूल गेट ५ परिसर",
  "Water supply for Camp Alpha — tanker needed": "शिबिर अल्फासाठी पाणीपुरवठा — टँकर आवश्यक",
  "Traffic signal override — Godavari Bridge": "वाहतूक सिग्नल अधिग्रहण — गोदावरी पूल",
  "In Progress": "प्रगतीपथावर",
  "Pending": "प्रलंबित",
  "Approved": "मंजूर",
  "Active": "सक्रिय",

  // ── War Room Log ──
  "Dist. Collector ": "जिल्हाधिकारी",
  "Admin": "प्रशासन",
  "MSRTC Nashik": "एमएसआरटीसी नाशिक",
  "SP Nashik": "एसपी नाशिक",
  "Revenue DM": "महसूल डीएम",
  "Police": "पोलीस",
  "System": "प्रणाली",
  "Health": "आरोग्य",
  "Municipal": "महानगरपालिका",
  "Disaster": "आपत्ती",
  "Revenue": "महसूल",
  "Approved crowd diversion plan — Entry 2 sealed, Gate 4 activated": "गर्दी वळवण्याची योजना मंजूर — प्रवेशद्वार २ बंद, गेट ४ सक्रिय",
  "Crowd density 9.2/m² alert generated — Ramkund Entry 2": "गर्दीची घनता ९.२/मी² इशारा निर्माण — रामकुंड प्रवेशद्वार २",
  "Ambulance escort request raised to Police — INC-8819": "रुग्णवाहिका बंदोबस्तासाठी पोलिसांकडे विनंती — INC-8819",
  "Camp 3 overflow shelter OFZ-B pre-authorized — pending activation": "शिबिर ३ अतिरिक्त निवारा OFZ-B पूर्व-मंजूर — सक्रियता प्रलंबित",
  "Shuttle SR-04 diversion confirmed — alternate route activated": "शटल SR-04 वळवण्याची पुष्टी — पर्यायी मार्ग सक्रिय",
  "Water tanker TK-22 dispatched — Panchvati Station 8 ETA 14:48": "पाण्याचा टँकर TK-22 रवाना — पंचवटी केंद्र ८ अंदाजे आगमन १४:४८",
  "Platoon 2 activated for Camp 3 shelter response": "शिबिर ३ निवारा प्रतिसादासाठी तुकडी २ सक्रिय",
  "Missing person CCTV match at Gate 5 — 61% confidence — sent to Patil": "गेट ५ येथे सीसीटीव्हीत हरवलेल्या व्यक्तीशी जुळणी — ६१% विश्वासार्हता — पाटील यांना पाठवले",
  "Ambulance access blocked — escalated to DCP for escort priority": "रुग्णवाहिकेचा मार्ग अडवला — बंदोबस्त प्राधान्यासाठी डीसीपींकडे वाढवले",
  "CM convoy route POL-002 approved — 15:30 ingress": "मुख्यमंत्री ताफा मार्ग POL-002 मंजूर — 15:30 प्रवेश",
  "Camp 3 load at 138% — alert raised to Collector": "शिबिर ३ भार १३८% — जिल्हाधिकाऱ्यांना इशारा दिला",
  "MP-1185 registered — broadcast to 22,000 pilgrims activated": "MP-1185 नोंदणीकृत — २२,००० यात्रेकरूंना प्रसारण सक्रिय",
  "decision": "निर्णय",
  "ai": "एआय",
  "escalate": "वाढ",
  "action": "कृती",
  "⚠ All actions logged for DPDP 2023 audit trail. AI actions marked separately and require human confirmation.":
    "⚠ सर्व कृती DPDP 2023 लेखापरीक्षण नोंदीसाठी नोंदवल्या जातात. एआय कृती स्वतंत्रपणे चिन्हांकित असून त्यांना मानवी पुष्टीकरण आवश्यक आहे.",

  // ── VIP Coordination ──
  "Chief Minister Nashik Visit": "मुख्यमंत्री नाशिक भेट",
  "Union Minister — Trimbakeshwar": "केंद्रीय मंत्री — त्र्यंबकेश्वर",
  "District Collector — Camp Inspect": "जिल्हाधिकारी — शिबिर पाहणी",
  "Confirmed": "पुष्टी झाली",
  "Security": "सुरक्षा",
  "ETA": "अंदाजित वेळ",
  "Escort": "बंदोबस्त",
  "Nashik Road → Ramkund Ghat (secured)": "नाशिक रोड → रामकुंड घाट (सुरक्षित)",
  "Trimbak Road (VIP lane)": "त्र्यंबक रस्ता (व्हीआयपी मार्गिका)",
  "Camp Alpha → Camp Beta": "शिबिर अल्फा → शिबिर बीटा",
  "SP Nashik + 2 Platoons": "एसपी नाशिक + २ तुकड्या",
  "DySP + 1 Platoon": "डीवायएसपी + १ तुकडी",
  "PSI + 4 Constables": "पीएसआय + ४ हवालदार",

  // ── Task Board ──
  "Task ID": "कार्य क्रमांक",
  "Title": "शीर्षक",
  "Department": "विभाग",
  "Priority": "प्राधान्य",
  "Owner": "जबाबदार",
  "Status": "स्थिती",
  "all": "सर्व",
  "police": "पोलीस",
  "health": "आरोग्य",
  "transport": "वाहतूक",
  "municipal": "महानगरपालिका",
  "disaster": "आपत्ती",
  "Crowd control Ramkund Entry 2": "गर्दी नियंत्रण — रामकुंड प्रवेशद्वार २",
  "VIP convoy route — CM Nashik visit": "व्हीआयपी ताफा मार्ग — सीएम नाशिक भेट",
  "Missing child — Panchvati Sector 7": "हरवलेले मूल — पंचवटी विभाग ७",
  "Camp Alpha — capacity relief needed": "शिबिर अल्फा — क्षमता सहाय्य आवश्यक",
  "Additional ambulance — Trimbak": "अतिरिक्त रुग्णवाहिका — त्र्यंबक",
  "Shuttle SR-04 diversion Trimbak": "शटल SR-04 वळवणे — त्र्यंबक",
  "Extra buses Nashik Road → Ramkund": "अतिरिक्त बस नाशिक रोड → रामकुंड",
  "Toilet blocks — deep clean Panchvati": "शौचालय — सखोल स्वच्छता पंचवटी",
  "Water tanker refill Station 8": "पाण्याचा टँकर पुनर्भरण — केंद्र ८",
  "Flash flood prep — Godavari banks": "अचानक पूर सज्जता — गोदावरी काठ",
  "RTO Office": "आरटीओ कार्यालय",
  "NMC Sanitation": "एनएमसी स्वच्छता विभाग",
  "JE NMC": "कनिष्ठ अभियंता एनएमसी",
  "NDRF Team B": "एनडीआरएफ पथक बी",

  // ── Agency Coordination Matrix ──
  "Tasks": "कामे",
  "Done": "पूर्ण",
  "Completion": "पूर्णता",
  "CM Office": "मुख्यमंत्री कार्यालय",

  // ── Task Creation vs Completion chart ──
  "Created": "तयार झाले",
  "Completed": "पूर्ण",
  "SLA Breach": "SLA उल्लंघन",
  "tasks": "कामे",

  // ── Responsibility Matrix ──
  "Domain": "क्षेत्र",
  "Primary": "प्राथमिक",
  "Secondary": "दुय्यम",
  "Trigger Condition": "चालना अट",
  "Escalation Chain": "वाढ साखळी",
  "Crowd Management": "गर्दी व्यवस्थापन",
  "Medical Emergencies": "वैद्यकीय आपत्कालीन स्थिती",
  "Water & Sanitation": "पाणी व स्वच्छता",
  "Transport & Traffic": "वाहतूक व रहदारी",
  "Shelter Overflow": "निवारा अतिरिक्त भार",
  "Disaster Response": "आपत्ती प्रतिसाद",
  "Missing Person": "हरवलेली व्यक्ती",
  "Public Communication": "सार्वजनिक संवाद",
  "Volunteers": "स्वयंसेवक",
  "All Depts": "सर्व विभाग",
  "Density >8/m²": "घनता >८/मी²",
  "Serious case / Amb block": "गंभीर प्रकरण / रुग्णवाहिका अडथळा",
  "Station empty / overflow": "केंद्र रिकामे / अतिरिक्त भार",
  "Route saturation >85%": "मार्ग संपृक्तता >८५%",
  "Camp >120% capacity": "शिबिर क्षमतेच्या >१२०%",
  "Flood / Fire / Structure": "पूर / आग / संरचना",
  "MP case registered": "हरवलेली व्यक्ती प्रकरण नोंदणीकृत",
  "Misinformation / alert": "चुकीची माहिती / इशारा",
  "DCP → Collector": "डीसीपी → जिल्हाधिकारी",
  "CMO → DCP → Civil Hosp": "सीएमओ → डीसीपी → नागरी रुग्णालय",
  "JE → Exec.Eng. → Collector": "कनिष्ठ अभियंता → कार्यकारी अभियंता → जिल्हाधिकारी",
  "MSRTC → RTO → DCP": "एमएसआरटीसी → आरटीओ → डीसीपी",
  "RO → Collector → CM": "महसूल अधिकारी → जिल्हाधिकारी → मुख्यमंत्री",
  "NDRF → DM → CM EOC": "एनडीआरएफ → डीएम → सीएम ईओसी",
  "PSI → Inspector → DCP": "पीएसआय → निरीक्षक → डीसीपी",
  "PRO → DM → CM": "जनसंपर्क अधिकारी → डीएम → मुख्यमंत्री",

  // ── Shahi Snan Planning ──
  "Shahi Snan Planning Board — Simhastha 2027": "शाही स्नान नियोजन फलक — सिंहस्थ २०२७",
  "Shravan Purnima": "श्रावण पौर्णिमा",
  "Simhastha Peak Day": "सिंहस्थ पर्वणी दिन",
  "Anant Chaturdashi": "अनंत चतुर्दशी",
  "Est. crowd": "अंदाजे गर्दी",
  "days away": "दिवस बाकी",
  "readiness": "सज्जता",
  "Pending Preparation Tasks": "प्रलंबित तयारी कामे",
  "Completed Preparation": "पूर्ण झालेली तयारी",
  "NDRF pre-position (D-7)": "एनडीआरएफ पूर्व-तैनाती (डी-७)",
  "Extra bus depot activation": "अतिरिक्त बस डेपो सक्रियता",
  "Additional medical camps (3)": "अतिरिक्त वैद्यकीय शिबिरे (३)",
  "Godavari Bridge traffic plan": "गोदावरी पूल वाहतूक योजना",
  "Volunteer training (D-14)": "स्वयंसेवक प्रशिक्षण (डी-१४)",
  "Mass evacuation route finalization": "मोठ्या प्रमाणावर स्थलांतर मार्ग अंतिमीकरण",
  "All-agency simulation drill": "सर्व-संस्था सराव कवायत",
  "Satellite comms backup": "उपग्रह संपर्क बॅकअप",
  "20 additional ambulances": "२० अतिरिक्त रुग्णवाहिका",
  "Media embargo protocol": "माध्यम प्रतिबंध प्रोटोकॉल",
  "Post-peak medical surge plan": "पर्वणीनंतर वैद्यकीय भार योजना",
  "Transport exit strategy": "वाहतूक निर्गमन धोरण",
  "Waste management scaling": "कचरा व्यवस्थापन विस्तार",
  "CM communication protocol approved": "सीएम संवाद प्रोटोकॉल मंजूर",
  "Hospital surge plan activated": "रुग्णालय भार योजना सक्रिय",
  "SITREP template ready": "सिटरेप टेम्प्लेट तयार",
  "Cross-agency MOU signed": "आंतर-संस्था सामंजस्य करार स्वाक्षरीकृत",
  "Crowd risk model calibrated": "गर्दी जोखीम प्रतिमान कॅलिब्रेट केले",
  "Digital twin scenario ready": "डिजिटल ट्विन परिस्थिती तयार",
  "Mutual aid agreements signed": "परस्पर सहाय्य करार स्वाक्षरीकृत",
  "Base camp allocation complete": "मुख्य शिबिर वाटप पूर्ण",
  "Police rotation plan signed": "पोलीस फेरबदल योजना स्वाक्षरीकृत",

  // ── Command Authority Chain ──
  "L1 — Field Officer": "एल१ — क्षेत्रीय अधिकारी",
  "L2 — Inspector / JE": "एल२ — निरीक्षक / कनिष्ठ अभियंता",
  "L2 — Dept Head / DCP": "एल२ — विभाग प्रमुख / डीसीपी",
  "L3 — District Collector": "एल३ — जिल्हाधिकारी",
  "L4 — CM Office / EOC": "एल४ — मुख्यमंत्री कार्यालय / ईओसी",
  "1,120 field staff": "१,१२० क्षेत्रीय कर्मचारी",
  "60 section officers": "६० विभाग अधिकारी",
  "12 dept heads": "१२ विभाग प्रमुख",
  "1 Collector": "१ जिल्हाधिकारी",
  "CM + 1 ADC": "मुख्यमंत्री + १ एडीसी",
  "Execute tasks, update status, flag alerts": "कामे पार पाडणे, स्थिती अद्ययावत करणे, इशारे नोंदवणे",
  "Approve L1 actions, assign resources, escalate": "एल१ कृती मंजूर करणे, संसाधने वाटप करणे, वाढवणे",
  "Approve major ops, inter-agency, resource calls": "मोठी कार्ये मंजूर करणे, आंतर-संस्था समन्वय, संसाधन विनंत्या",
  "Approve cross-agency escalations, CM escalation": "आंतर-संस्था वाढ मंजूर करणे, मुख्यमंत्री स्तरावर वाढ",
  "Final authority — national-level response & media": "अंतिम प्राधिकरण — राष्ट्रीय स्तरावरील प्रतिसाद व माध्यमे",

  // ── Audit Log + Officer Board ──
  "Resource": "संसाधन",
  "22,840 audit log entries recorded today · All entries immutable · DPDP 2023 compliant":
    "आज २२,८४० लेखापरीक्षण नोंदी नोंदवल्या · सर्व नोंदी अपरिवर्तनीय · DPDP 2023 अनुरूप",
  "Police L2": "पोलीस एल२",
  "Health L2": "आरोग्य एल२",
  "Police L1": "पोलीस एल१",
  "Police L3": "पोलीस एल३",
  "Approved crowd diversion — Entry 2": "गर्दी वळवणे मंजूर — प्रवेशद्वार २",
  "Reviewed AI heatstroke flag Zone D": "एआय उष्माघात इशारा विभाग डी पुनरावलोकन केले",
  "Logged water tanker delay — Station 8": "पाणी टँकर विलंब नोंदवला — केंद्र ८",
  "Updated shuttle SR-04 diversion route": "शटल SR-04 वळण मार्ग अद्ययावत केला",
  "Auto-suppressed duplicate fire alert Trimbak": "त्र्यंबक येथील डुप्लिकेट आग इशारा स्वयं-दाबला",
  "Initiated MP search — MP-1185": "हरवलेली व्यक्ती शोध सुरू — MP-1185",
  "Escalated ambulance block — Camp Beta": "रुग्णवाहिका अडथळा वाढवला — शिबिर बीटा",
  "Approved CM convoy route — POL-002": "सीएम ताफा मार्ग मंजूर — POL-002",
  "Responding": "प्रतिसाद देत आहे",
  "On Duty": "कर्तव्यावर",
  "Emergency": "आणीबाणी",
  "Ramkund Ghat": "रामकुंड घाट",
  "Panchvati": "पंचवटी",
  "Kalaram Temple": "काळाराम मंदिर",
  "Trimbak Rd Camp": "त्र्यंबक रोड कॅम्प",
  "Panchvati Zone": "पंचवटी झोन",
  "Nashik Road Stn": "नाशिक रोड स्थानक",
  "Missing Person Search": "बेपत्ता व्यक्ती शोध",
  "Entry Gate Mgmt": "प्रवेशद्वार व्यवस्थापन",
  "Ambulance Coord": "रुग्णवाहिका समन्वय",
  "Transport Coord": "वाहतूक समन्वय",
  "Key Officers": "प्रमुख अधिकारी",
  "On Emergency": "आणीबाणीत",
  "Total Tasks": "एकूण कामे",

  // ═══════════════ Governance.jsx ═══════════════

  // ── Responsible AI banner ──
  "MAHA AI — RESPONSIBLE AI GOVERNANCE FRAMEWORK · DPDP 2023 · ALL 7 PRINCIPLES ACTIVE":
    "महा एआय — जबाबदार एआय प्रशासन चौकट · DPDP 2023 · सर्व ७ तत्त्वे सक्रिय",
  "Maha Kumbh AI · Maha AI operates under DPDP 2023 · IT Act 2000 · MeitY AI SOP · CERT-In Guidelines · No automated punitive action · Full transparency":
    "महा कुंभ एआय · महा एआय DPDP 2023 · IT Act 2000 · MeitY एआय SOP · CERT-In मार्गदर्शक तत्त्वांनुसार कार्यरत · कोणतीही स्वयंचलित दंडात्मक कृती नाही · संपूर्ण पारदर्शकता",
  "Human-in-Loop": "मानवी सहभाग",
  "Explainability": "स्पष्टीकरणक्षमता",
  "Accountability": "उत्तरदायित्व",
  "Transparency": "पारदर्शकता",
  "Privacy-by-Design": "गोपनीयता-रचित",
  "No Punitive AI Action": "दंडात्मक एआय कृती नाही",
  "Enforced": "अंमलात",
  "Compliant": "अनुपालित",
  "Zero enforcement actions without human officer approval. AI flags routed to authorised officer before any action.":
    "मानवी अधिकाऱ्याच्या मंजुरीशिवाय कोणतीही अंमलबजावणी कृती नाही. कोणतीही कृती होण्यापूर्वी एआय इशारे अधिकृत अधिकाऱ्याकडे पाठवले जातात.",
  "SHAP value explanations available for all model predictions. Confidence band + feature attribution displayed.":
    "सर्व प्रतिमान अंदाजांसाठी SHAP मूल्य स्पष्टीकरणे उपलब्ध. विश्वासार्हता पट्टा + वैशिष्ट्य श्रेय दर्शवले जाते.",
  "Every action — human or AI — logged immutably. No anonymous actions. Audit trail accessible to oversight.":
    "प्रत्येक कृती — मानवी असो वा एआय — अपरिवर्तनीयपणे नोंदवली जाते. कोणतीही अनामिक कृती नाही. देखरेखीसाठी लेखापरीक्षण नोंद उपलब्ध.",
  "Monthly AI transparency report published. All model purposes, training data types and limitations disclosed.":
    "मासिक एआय पारदर्शकता अहवाल प्रकाशित. सर्व प्रतिमान उद्देश, प्रशिक्षण डेटा प्रकार व मर्यादा उघड केल्या जातात.",
  "Anonymisation at sensor source for CCTV. No raw biometric stored. PII minimised to operational necessity.":
    "सीसीटीव्हीसाठी संवेदक स्रोतावरच निनावीकरण. कोणतेही कच्चे जैवमापन साठवले जात नाही. PII केवळ कार्यात्मक आवश्यकतेपुरते मर्यादित.",
  "Only strictly required data collected per operation. No retention beyond stated purpose. Auto-delete active.":
    "प्रत्येक कार्यासाठी केवळ आवश्यक तेवढाच डेटा संकलित. नमूद उद्देशापलीकडे कोणतेही जतन नाही. स्वयं-हटवणे सक्रिय.",
  "AI cannot trigger arrest, detention, fine or denial of service. These require human DCP/Collector approval.":
    "एआय अटक, स्थानबद्धता, दंड किंवा सेवा नकार सुरू करू शकत नाही. यासाठी मानवी डीसीपी/जिल्हाधिकारी मंजुरी आवश्यक.",

  // ── DPDP Controls ──
  "Last audit": "शेवटचे लेखापरीक्षण",
  "Data Minimisation": "डेटा किमानीकरण",
  "Consent Management": "संमती व्यवस्थापन",
  "Purpose Limitation": "उद्देश मर्यादन",
  "Data Retention": "डेटा जतन",
  "Right to Erasure": "नष्ट करण्याचा अधिकार",
  "Privacy by Design": "गोपनीयता-रचित",
  "AI Explainability ": "एआय स्पष्टीकरणक्षमता",
  "Implemented": "अंमलात आणले",
  "Only operational data collected": "केवळ कार्यात्मक डेटा संकलित",
  "Consent recorded for all biometric use": "सर्व जैवमापन वापरासाठी संमती नोंदवली",
  "Data used only for safety operations": "डेटा केवळ सुरक्षा कार्यांसाठी वापरला",
  "30-day retention policy active": "३०-दिवसीय जतन धोरण सक्रिय",
  "Portal active, 2 requests processed": "पोर्टल सक्रिय, २ विनंत्या निकाली",
  "Anonymisation at source in camera feeds": "कॅमेरा फीडमध्ये स्रोतावरच निनावीकरण",
  "Human-in-loop mandatory for enforcement": "अंमलबजावणीसाठी मानवी सहभाग अनिवार्य",
  "SHAP explanations available for all models": "सर्व प्रतिमानांसाठी SHAP स्पष्टीकरणे उपलब्ध",

  // ── Consent Management Panel ──
  "Data Category": "डेटा प्रवर्ग",
  "Legal Basis": "कायदेशीर आधार",
  "Consented": "संमती दिली",
  "Withdrawn": "मागे घेतली",
  "Retention": "जतन कालावधी",
  "Purpose": "उद्देश",
  "Non-PII": "गैर-PII",
  "CCTV — Aggregate crowd analytics": "सीसीटीव्ही — एकत्रित गर्दी विश्लेषण",
  "Biometric — Missing person search": "जैवमापन — हरवलेली व्यक्ती शोध",
  "Helpline call recording": "हेल्पलाइन कॉल ध्वनिमुद्रण",
  "Pilgrim WhatsApp opt-in": "यात्रेकरू व्हॉट्सअॅप संमती",
  "SMS advisory registration": "एसएमएस सूचना नोंदणी",
  "Volunteer GPS tracking": "स्वयंसेवक जीपीएस ट्रॅकिंग",
  "Medical camp patient data": "वैद्यकीय शिबिर रुग्ण डेटा",
  "Public safety · DMA 2005": "सार्वजनिक सुरक्षा · DMA 2005",
  "Explicit consent · DPDP": "स्पष्ट संमती · DPDP",
  "Informed consent at IVR": "IVR वर सुज्ञ संमती",
  "Explicit consent": "स्पष्ट संमती",
  "Employment consent": "नोकरी संमती",
  "Medical consent": "वैद्यकीय संमती",
  "Crowd density monitoring": "गर्दी घनता निरीक्षण",
  "MP identification only": "केवळ हरवलेली व्यक्ती ओळख",
  "Service quality + training": "सेवा गुणवत्ता + प्रशिक्षण",
  "Safety advisories only": "केवळ सुरक्षा सूचना",
  "Field coordination": "क्षेत्रीय समन्वय",
  "Treatment + referral": "उपचार + संदर्भ",
  "30 days": "३० दिवस",
  "Case close": "प्रकरण बंद होईपर्यंत",
  "90 days": "९० दिवस",
  "Event end": "कार्यक्रम समाप्तीपर्यंत",
  "Shift end": "पाळी समाप्तीपर्यंत",
  "5 years": "५ वर्षे",

  // ── Right to Erasure ──
  "Right to Erasure Requests — Processed": "नष्ट करण्याच्या विनंत्या — निकाली",
  "Filed": "दाखल",
  "in": "मध्ये",
  "days": "दिवस",
  "Completed": "पूर्ण",
  "Pilgrim — Nasir Khan": "यात्रेकरू — नासिर खान",
  "Volunteer — S. Patil": "स्वयंसेवक — एस. पाटील",
  "Call recording deletion": "कॉल ध्वनिमुद्रण हटवणे",
  "GPS data erasure": "जीपीएस डेटा नष्टीकरण",

  // ── Data Retention Dashboard ──
  "Retention Period": "जतन कालावधी",
  "Auto-Delete": "स्वयं-हटवणे",
  "Next Purge": "पुढील नष्टीकरण",
  "Stored": "साठवले",
  "Auto": "स्वयंचलित",
  "Manual": "स्वहस्ते",
  "Preserved": "जतन केलेले",
  "CCTV footage — non-event": "सीसीटीव्ही चित्रण — कार्यक्रमेतर",
  "CCTV footage — incident": "सीसीटीव्ही चित्रण — घटना",
  "Audit logs — all actions": "लेखापरीक्षण नोंदी — सर्व कृती",
  "Helpline recordings": "हेल्पलाइन ध्वनिमुद्रणे",
  "Medical patient records": "वैद्यकीय रुग्ण नोंदी",
  "Field officer body cam": "क्षेत्रीय अधिकारी बॉडी कॅम",
  "WhatsApp advisory logs": "व्हॉट्सअॅप सूचना नोंदी",
  "AI model inference logs": "एआय प्रतिमान अनुमान नोंदी",
  "2 years": "२ वर्षे",
  "7 years": "७ वर्षे",
  "Event + 30": "कार्यक्रम + ३०",

  // ── Privacy-by-Design ──
  "Module": "घटक",
  "Anonymisation": "निनावीकरण",
  "Pseudonymisation": "छद्मनामीकरण",
  "Min. Data": "किमान डेटा",
  "Biometric Stored": "जैवमापन साठवले",
  "Consent Basis": "संमती आधार",
  "Yes": "होय",
  "No": "नाही",
  "CCTV Surveillance": "सीसीटीव्ही निगराणी",
  "Helpline / IVR": "हेल्पलाइन / IVR",
  "WhatsApp Advisory": "व्हॉट्सअॅप सूचना",
  "Medical Camp Records": "वैद्यकीय शिबिर नोंदी",
  "Missing Person Facial AI": "हरवलेली व्यक्ती चेहरा-ओळख एआय",
  "Field Officer GPS": "क्षेत्रीय अधिकारी जीपीएस",
  "Volunteer Body Cam": "स्वयंसेवक बॉडी कॅम",
  "At camera firmware": "कॅमेरा फर्मवेअरमध्येच",
  "Post-call (24h)": "कॉलनंतर (२४ तास)",
  "Broadcast only": "केवळ प्रसारण",
  "Referral de-ID": "संदर्भ निनावीकरण",
  "No raw storage": "कच्चे साठवण नाही",
  "After shift": "पाळीनंतर",
  "30-day auto-delete": "३०-दिवसीय स्वयं-हटवणे",
  "Zone-level agg only": "केवळ विभाग-स्तरीय एकत्रीकरण",
  "Caller ID masked": "कॉलर आयडी लपवलेला",
  "No reply tracking": "प्रत्युत्तर ट्रॅकिंग नाही",
  "Patient token ID": "रुग्ण टोकन आयडी",
  "Match ID only": "केवळ जुळणी आयडी",
  "Officer code used": "अधिकारी संकेतांक वापरला",
  "Event code tagged": "कार्यक्रम संकेतांक टॅग केला",
  "Public interest": "सार्वजनिक हित",
  "Explicit + informed": "स्पष्ट + सुज्ञ",
  "Opt-in": "संमतीने सहभाग",
  "DPDP explicit": "DPDP स्पष्ट",
  "Employment": "नोकरी",
  "Informed consent": "सुज्ञ संमती",

  // ── Responsible AI tab ──
  "7 Responsible AI Principles — Detailed Status": "७ जबाबदार एआय तत्त्वे — तपशीलवार स्थिती",

  // ── AI Model Governance Register ──
  "AI Model": "एआय प्रतिमान",
  "Human Loop": "मानवी सहभाग",
  "Explainer": "स्पष्टीकरणकर्ता",
  "Conf. Threshold": "विश्वासार्हता उंबरठा",
  "Bias Check": "पूर्वग्रह तपासणी",
  "Last Review": "शेवटचे पुनरावलोकन",
  "Vendor": "पुरवठादार",
  "Pass": "उत्तीर्ण",
  "Crowd Density Estimator": "गर्दी घनता अंदाजक",
  "Stampede Risk Predictor": "चेंगराचेंगरी जोखीम भाकितकर्ता",
  "AI Heatstroke Forecaster": "एआय उष्माघात भाकितकर्ता",
  "Face-Match (MP Search)": "चेहरा-जुळणी (हरवलेली व्यक्ती शोध)",
  "Misinfo Detection": "चुकीची माहिती शोध",
  "Disease Outbreak Predictor": "साथरोग उद्रेक भाकितकर्ता",
  "Traffic Signal AI": "वाहतूक सिग्नल एआय",
  "Resource Demand Forecast": "संसाधन मागणी अंदाज",
  "Footfall & density": "पदचिन्ह व घनता",
  "Stampede probability 6h": "चेंगराचेंगरी संभाव्यता ६ तास",
  "Heat-illness prediction": "उष्णता-आजार भाकीत",
  "Missing person ID only": "केवळ हरवलेली व्यक्ती ओळख",
  "False content flagging": "चुकीचा मजकूर चिन्हांकन",
  "Epidemic early warning": "साथरोग पूर्वसूचना",
  "Dynamic signal override": "गतिमान सिग्नल अधिग्रहण",
  "Supply-demand optimise": "पुरवठा-मागणी अनुकूलन",
  "⚠ All AI models require human officer approval before any enforcement, punitive or access-denial action — DPDP 2023 · MeitY AI SOP 2023":
    "⚠ सर्व एआय प्रतिमानांना कोणतीही अंमलबजावणी, दंडात्मक किंवा प्रवेश-नकार कृतीपूर्वी मानवी अधिकाऱ्याची मंजुरी आवश्यक — DPDP 2023 · MeitY एआय SOP 2023",

  // ── Transparency Report ──
  "Month": "महिना",
  "AI Actions": "एआय कृती",
  "Human Reviewed": "मानवी पुनरावलोकन झालेले",
  "Officer Overrides": "अधिकारी अधिलिखन",
  "Review Rate": "पुनरावलोकन दर",
  "Apr 2027": "एप्रिल २०२७",
  "May 2027": "मे २०२७",
  "Jun 2027": "जून २०२७",
  "Published on MahaGov portal": "MahaGov पोर्टलवर प्रकाशित",
  "Available under RTI": "RTI अंतर्गत उपलब्ध",
  "DPDP 2023 compliant": "DPDP 2023 अनुरूप",

  // ── RBAC ──
  "Role": "भूमिका",
  "Access Level": "प्रवेश स्तर",
  "Users": "वापरकर्ते",
  "Permissions": "परवानग्या",
  "Optional": "ऐच्छिक",
  "CM Office ": "मुख्यमंत्री कार्यालय",
  "Collector": "जिल्हाधिकारी",
  "SP / DCP": "एसपी / डीसीपी",
  "Section Officer": "विभाग अधिकारी",
  "Field Officer": "क्षेत्रीय अधिकारी",
  "Read Only": "केवळ वाचन",
  "L4 — National": "एल४ — राष्ट्रीय",
  "L3 — District": "एल३ — जिल्हा",
  "L2 — Dept Head": "एल२ — विभाग प्रमुख",
  "L2 — Dept": "एल२ — विभाग",
  "L1 — Field": "एल१ — क्षेत्रीय",
  "L0 — Observer": "एल० — निरीक्षक",
  "View-all, Approve-escalations": "सर्व पाहणे, वाढ मंजूर करणे",
  "View-all, Approve-operations": "सर्व पाहणे, कार्ये मंजूर करणे",
  "View-dept, Approve-tasks, Assign": "विभाग पाहणे, कामे मंजूर करणे, वाटप करणे",
  "View-dept, Execute-tasks": "विभाग पाहणे, कामे पार पाडणे",
  "View-assigned, Update-status": "नेमून दिलेले पाहणे, स्थिती अद्ययावत करणे",
  "View-summary only": "केवळ सारांश पाहणे",

  // ── Access Activity + Sessions ──
  "Access Activity by Role — Today": "आजची भूमिकानिहाय प्रवेश हालचाल",
  "Logins": "प्रवेश",
  "Actions": "कृती",
  "Active Sessions — Live": "सक्रिय सत्रे — थेट",
  "No MFA": "MFA नाही",
  "Nodal Officer": "नोडल अधिकारी",
  "AI System Bot": "एआय प्रणाली बॉट",
  "Admin L3": "प्रशासन एल३",

  // ── Failed Logins ──
  "Failed Login Attempts — Today": "आजचे अयशस्वी प्रवेश प्रयत्न",
  "attempts": "प्रयत्न",
  "Unknown": "अज्ञात",
  "Blocked": "अवरोधित",
  "Monitored": "निरीक्षणाधीन",

  // ── Audit Trail ──
  "Log ID": "नोंद क्रमांक",
  "User": "वापरकर्ता",
  "Action": "कृती",
  "Time": "वेळ",
  "Immutable — SHA-256 hash chain": "अपरिवर्तनीय — SHA-256 हॅश साखळी",
  "7-year retention enforced": "७-वर्षीय जतन अंमलात",
  "Showing 8 of": "८ दाखवत आहे, एकूण",
  "entries": "नोंदी",

  // ── SOC / SIEM ──
  "Events": "घटना",
  "Alerts": "इशारे",
  "Intrusion": "घुसखोरी",
  "Data Exfil": "डेटा वहन",
  "Abuse": "गैरवापर",
  "Config": "संरचना",
  "Privilege": "विशेषाधिकार",
  "Integrity": "अखंडता",
  "Unauthorised Access": "अनधिकृत प्रवेश",
  "API Rate Limit": "API दर मर्यादा",
  "Unusual Login": "असामान्य प्रवेश",
  "Data Export Attempt": "डेटा निर्यात प्रयत्न",
  "Cert Expiry Warning": "प्रमाणपत्र मुदतसमाप्ती इशारा",
  "SQL Injection Probe": "SQL इंजेक्शन तपासणी",
  "Brute Force Login": "ब्रूट फोर्स प्रवेश",
  "CORS Policy Violation": "CORS धोरण उल्लंघन",
  "Privilege Escalation": "विशेषाधिकार वाढ",
  "File Integrity Alert": "फाइल अखंडता इशारा",
  "External IP 203.x.x.x": "बाह्य आयपी 203.x.x.x",
  "Mobile App Agent": "मोबाइल अॅप एजंट",
  "Field Officer FO-1140": "क्षेत्रीय अधिकारी FO-1140",
  "External Partner Sys.": "बाह्य भागीदार प्रणाली",
  "API Gateway Cert": "API गेटवे प्रमाणपत्र",
  "External IP 185.x.x.x": "बाह्य आयपी 185.x.x.x",
  "External IP 45.x.x.x": "बाह्य आयपी 45.x.x.x",
  "Unregistered App": "अनोंदणीकृत अॅप",
  "Internal IP — Dev Env": "अंतर्गत आयपी — विकास वातावरण",
  "Maha Kumbh AI App Server": "महा कुंभ एआय अॅप सर्व्हर",
  "Throttled": "मर्यादित",
  "Renewing": "नूतनीकरणाधीन",
  "Resolved": "निकाली",

  // ── Cyber Risk ──
  "Incidents": "घटना",
  "Residual": "उर्वरित",
  "Risk": "जोखीम",
  "Inherent Risk": "अंगभूत जोखीम",
  "Residual Risk": "उर्वरित जोखीम",
  "External Intrusion": "बाह्य घुसखोरी",
  "Data Exfiltration": "डेटा वहन",
  "Insider Threat": "अंतर्गत धोका",
  "Supply Chain Attack": "पुरवठा साखळी हल्ला",
  "Credential Attack": "प्रमाणपत्र हल्ला",
  "DDoS / Service Abuse": "DDoS / सेवा गैरवापर",

  // ── Data Sovereignty ──
  "DATA SOVEREIGNTY — ALL DATA WITHIN INDIA · NIC CERTIFIED · DPDP 2023 COMPLIANT":
    "डेटा सार्वभौमत्व — सर्व डेटा भारतातच · NIC प्रमाणित · DPDP 2023 अनुरूप",
  "India's Data — Stays in India": "भारताचा डेटा — भारतातच राहतो",
  "All Maha Kumbh AI / Maha AI data stored exclusively on NIC cloud infrastructure within India · No cross-border data transfer without MHA clearance · STQC certified · CERT-In compliant · Zero foreign cloud dependency for citizen PII":
    "सर्व महा कुंभ एआय / महा एआय डेटा केवळ भारतातील NIC क्लाऊड पायाभूत सुविधेवर साठवला जातो · MHA मंजुरीशिवाय कोणतेही सीमापार डेटा हस्तांतरण नाही · STQC प्रमाणित · CERT-In अनुरूप · नागरिक PII साठी परदेशी क्लाऊडवर शून्य अवलंबित्व",
  "Cert": "प्रमाणपत्र",
  "NIC Cloud — Primary (Mumbai)": "NIC क्लाऊड — प्राथमिक (मुंबई)",
  "NIC Cloud — DR (Hyderabad)": "NIC क्लाऊड — आपत्ती पुनर्प्राप्ती (हैदराबाद)",
  "Maha Kumbh AI App Servers": "महा कुंभ एआय अॅप सर्व्हर्स",
  "Database Cluster": "डेटाबेस क्लस्टर",
  "VSAT Comms — EOC": "VSAT संपर्क — ईओसी",
  "AI Inference Cluster": "एआय अनुमान क्लस्टर",
  "Primary DC": "प्राथमिक डेटा केंद्र",
  "Disaster Rec.": "आपत्ती पुनर्प्राप्ती",
  "Compute": "संगणन",
  "Data": "डेटा",
  "Comms": "संपर्क",
  "AI Compute": "एआय संगणन",
  "Mumbai, India": "मुंबई, भारत",
  "Hyderabad, India": "हैदराबाद, भारत",
  "Maharashtra NIC": "महाराष्ट्र NIC",
  "NIC Mumbai (encrypted)": "NIC मुंबई (एन्क्रिप्टेड)",
  "Nashik EOC — India": "नाशिक ईओसी — भारत",
  "NIC HPC — Pune": "NIC HPC — पुणे",
  "MeitY Tier-3": "MeitY टियर-३",
  "STQC certified": "STQC प्रमाणित",
  "DPDP 2023 ": "DPDP 2023",
  "DoT licensed": "DoT परवानाकृत",
  "MeitY AI SOP": "MeitY एआय SOP",
  "Live": "थेट",
  "Standby": "सज्ज",

  // ── Data Residency ──
  "Framework": "चौकट",
  "Requirement": "आवश्यकता",
  "Verification": "पडताळणी",
  "DPDP Act 2023": "DPDP कायदा २०२३",
  "IT Act 2000": "IT कायदा २०००",
  "MeitY Policy": "MeitY धोरण",
  "STQC": "STQC",
  "CERT-In": "CERT-In",
  "NIC Policy": "NIC धोरण",
  "Personal data of Indian citizens — within India": "भारतीय नागरिकांचा वैयक्तिक डेटा — भारतातच",
  "Sensitive data — encrypted in transit + at rest": "संवेदनशील डेटा — प्रवासात व साठवणीत एन्क्रिप्टेड",
  "Govt systems on NIC/empanelled cloud only": "सरकारी प्रणाली केवळ NIC/सूचीबद्ध क्लाऊडवरच",
  "Security audit of critical govt software": "महत्त्वाच्या सरकारी सॉफ्टवेअरचे सुरक्षा लेखापरीक्षण",
  "Cyber incident reporting within 6h": "६ तासांत सायबर घटना अहवाल",
  "No cross-border data transfer without MHA clearance": "MHA मंजुरीशिवाय कोणतेही सीमापार डेटा हस्तांतरण नाही",
  "NIC geo-fencing active": "NIC भू-कुंपण सक्रिय",
  "AES-256 + TLS 1.3": "AES-256 + TLS 1.3",
  "NIC Mumbai + Hyderabad": "NIC मुंबई + हैदराबाद",
  "STQC cert valid": "STQC प्रमाणपत्र वैध",
  "SOC auto-reports active": "SOC स्वयं-अहवाल सक्रिय",
  "Firewall egress blocked": "फायरवॉल निर्गमन अवरोधित",

  // ── Bhasini ──
  "BHASINI — MeitY NATIONAL LANGUAGE TRANSLATION MISSION · RESPONSIBLE MULTILINGUAL AI":
    "भाषिणी — MeitY राष्ट्रीय भाषा अनुवाद अभियान · जबाबदार बहुभाषिक एआय",
  "Multilingual AI Module": "बहुभाषिक एआय घटक",
  "10 Indian languages · constitutional obligation for linguistic equality · Maha Kumbh AI advisories broadcast in all supported languages via Bhasini API · Responsible AI bias testing per language · Human review before critical advisories":
    "१० भारतीय भाषा · भाषिक समानतेचे घटनात्मक बंधन · भाषिणी API द्वारे सर्व समर्थित भाषांमध्ये महा कुंभ एआय सूचना प्रसारित · प्रत्येक भाषेसाठी जबाबदार एआय पूर्वग्रह चाचणी · गंभीर सूचनांपूर्वी मानवी पुनरावलोकन",
  "Language Coverage — Bhasini Integration": "भाषा व्याप्ती — भाषिणी एकात्मीकरण",
  "Language": "भाषा",
  "Script": "लिपी",
  "Accuracy": "अचूकता",
  "Advisories": "सूचना",
  "Helpline Q.": "हेल्पलाइन प्रश्न",
  "Marathi": "मराठी",
  "Hindi": "हिंदी",
  "Gujarati": "गुजराती",
  "English": "इंग्रजी",
  "Tamil": "तमिळ",
  "Telugu": "तेलुगू",
  "Kannada": "कन्नड",
  "Urdu": "उर्दू",
  "Bengali": "बंगाली",
  "Punjabi": "पंजाबी",
  "Devanagari": "देवनागरी",
  "Latin": "लॅटिन",
  "Nastaliq": "नस्तालिक",
  "Gurmukhi": "गुरुमुखी",
  "Review": "पुनरावलोकन",

  // ── Bhasini Responsible AI checklist ──
  "Bhasini Responsible AI Checklist": "भाषिणी जबाबदार एआय तपासणी सूची",
  "Gender-neutral translation": "लिंग-तटस्थ भाषांतर",
  "Regional dialect sensitivity": "प्रादेशिक बोलीभाषा संवेदनशीलता",
  "No added religious tone": "कोणताही धार्मिक स्वर जोडलेला नाही",
  "Explainability per translation": "प्रत्येक भाषांतरासाठी स्पष्टीकरणक्षमता",
  "Human review — critical alerts": "मानवी पुनरावलोकन — गंभीर इशारे",
  "Bias test — minority languages": "पूर्वग्रह चाचणी — अल्पसंख्याक भाषा",
  "Source attribution": "स्रोत श्रेय",
  "No gendered pronoun bias detected in 98.4% of outputs": "९८.४% निष्पत्तींमध्ये कोणताही लिंगाधारित सर्वनाम पूर्वग्रह आढळला नाही",
  "Nashik Marathi dialect trained separately": "नाशिक मराठी बोलीभाषेचे स्वतंत्र प्रशिक्षण",
  "Safety-critical advisories are tone-neutral": "सुरक्षा-महत्त्वाच्या सूचना स्वर-तटस्थ आहेत",
  "Confidence score shown to human reviewer": "मानवी पुनरावलोकनकर्त्याला विश्वासार्हता गुण दर्शवला जातो",
  "All critical advisories reviewed before multilingual broadcast": "बहुभाषिक प्रसारणापूर्वी सर्व गंभीर सूचनांचे पुनरावलोकन",
  "Bengali model in additional bias review": "बंगाली प्रतिमान अतिरिक्त पूर्वग्रह पुनरावलोकनात",
  "All translations cite original advisory ID": "सर्व भाषांतरे मूळ सूचना क्रमांक नमूद करतात",
  "Uptime": "कार्यरत वेळ",
  "MeitY Certified": "MeitY प्रमाणित",
  "Constitutional Art. 343": "घटनात्मक अनुच्छेद ३४३",
  "⚠ Human review mandatory for all critical safety advisories before multilingual broadcast":
    "⚠ बहुभाषिक प्रसारणापूर्वी सर्व गंभीर सुरक्षा सूचनांसाठी मानवी पुनरावलोकन अनिवार्य",
};

export default shard7;
